import gql from "graphql-tag";
export const patientListQuery = `
query ($where: JSON, $last: Int, $first: Int) {
  allCtscans(where: $where, last: $last, first: $first) {
    totalCount
    Ctscans {
      id
      intervaporid
      preliminaryanalysispath
      scandate
      treatmentplanpath
      scanseriesuid
      siteid
      referenceid
      enablerequestip3
      ip3requestedon
    }
  }
}
`;
export const siteListQuery = `query($where:JSON,$last: Int, $first: Int){
    allSites (where:$where,last: $last, first: $first){
      Sites {
        name
        siteid
        id
      }
    }
  }`;
export const saveCTScan = gql`
  mutation saveCtscans($obj: CtscansInput!) {
    saveCtscans(obj: $obj) {
      id
      active
    }
  }
`;

export const getCtScanData = (id) => `{
  allCtscans(where:{id:${id},active:1}){
    Ctscans{
       comments
      filepath
      createdon
      id
      intervaporid
      active
      siteid
      scandate
      scanseriesuid
      referenceid
      enablerequestip3
      preliminaryanalysispath
      treatmentplanpath
      acquisitiondate
      preliminaryanalysiscomments
      treatmentplancomments
    }
  }
}`;

//TreatMent History Query
export const saveTreatmentHistory = `
mutation ($obj: TreatmenthistoryInput!) {
  saveTreatmenthistory(obj: $obj) {
    active
    comments
    createdby
    createdon
    ctscanid
    id
    segments
    treatmentdate
    updatedby
  } 
}
`;

export const allTreatmentHistories = `query($where:JSON){
  allTreatmenthistories(where:$where){
    Treatmenthistories{
      id
      comments
      ctscanid
      segments
      treatmentdate
    }
  }
}`;

export const getEmailTemplate = `query($id:ID!,$siteid:ID!){
  Emailtemplate(id:$id){
        id
        message
        kind
        subject
      }
    Site(id:$siteid){
      name
    }
}`;
export const ctscanRequestIP3 = gql`
  mutation CtscansRequestIP3($ctId: Int) {
    CtscansRequestIP3(ctId: $ctId)
  }
`;
export const CtscansUploadPA = gql`
  mutation CtscansUploadPA(
    $uniqueId: Int
    $emailMessage: String
    $filename: String
    $comments: String
  ) {
    CtscansUploadPA(
      uniqueId: $uniqueId
      emailMessage: $emailMessage
      filename: $filename
      comments: $comments
    )
  }
`;
export const CtscansUploadTP = gql`
  mutation CtscansUploadTP(
    $uniqueId: Int
    $emailMessage: String
    $filename: String
    $comments: String
  ) {
    CtscansUploadTP(
      uniqueId: $uniqueId
      emailMessage: $emailMessage
      filename: $filename
      comments: $comments
    )
  }
`;
export const CtscansUploadCtscan = gql`
  mutation CtscansUploadCtscan(
    $siteId: Int
    $initials: String
    $birthYear: Int
    $comments: String
    $referenceId: String
    $filename: JSON
    $rescanIntervaporId: String
  ) {
    CtscansUploadCtscan(
      siteId: $siteId
      initials: $initials
      birthYear: $birthYear
      comments: $comments
      referenceId: $referenceId
      filename: $filename
      rescanIntervaporId: $rescanIntervaporId
    )
  }
`;
export const uploadTracker=`query Uploadtracker($id: ID!) {
  Uploadtracker(id: $id) {
    id
    status
  }
}`